import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import BilderAndObservasjonsbilder from "./BilderAndObservasjonsbilder";

import {
  deleteMiljogebyrerBilder,
  getMiljogebyr,
  getMiljogebyrBilder,
  getMiljogebyrerHistorikk,
  putMiljogebyrerBilder,
} from "../../../../actions/miljogebyrerActions";
import {
  deleteMiljokontrollObservasjonBilde,
  getMiljokontrollBilder,
  putMiljokontrollObservasjonBilde,
} from "../../../../actions/miljokontrollerActions";

export default function BilderAndMiljokontrollsobservasjonsbilderContainer({
  miljogebyrId,
  ...rest
}) {
  const dispatch = useDispatch();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const miljogebyrBilder = useSelector(
    (state) => state.miljogebyrBilder[miljogebyrId],
  );
  const miljokontrollerThumbnailBilder = useSelector(
    (state) => state.miljokontrollerThumbnailBilder,
  );
  const miljokontrollerLightboxBilder = useSelector(
    (state) => state.miljokontrollerLightboxBilder,
  );
  const getMiljogebyrAction = useCallback(
    (id) => dispatch(getMiljogebyr(id)),
    [dispatch],
  );
  const getMiljogebyrBilderAction = useCallback(
    (id, params) => dispatch(getMiljogebyrBilder(id, params)),
    [dispatch],
  );
  const putMiljogebyrerBilderAction = useCallback(
    (id, bildeId, payload) =>
      dispatch(putMiljogebyrerBilder(id, bildeId, payload)),
    [dispatch],
  );
  const deleteMiljogebyrerBilderAction = useCallback(
    (id, bildeId) => dispatch(deleteMiljogebyrerBilder(id, bildeId)),
    [dispatch],
  );
  const deleteMiljokontrollObservasjonBildeAction = useCallback(
    (bildeId, miljokontrollId, observasjonId, getAllAfterUpdateSuccess) =>
      dispatch(
        deleteMiljokontrollObservasjonBilde(
          bildeId,
          miljokontrollId,
          observasjonId,
          getAllAfterUpdateSuccess,
        ),
      ),
    [dispatch],
  );
  const getMiljokontrollBilderAction = useCallback(
    (id, params) => dispatch(getMiljokontrollBilder(id, params)),
    [dispatch],
  );
  const putMiljokontrollObservasjonBildeAction = useCallback(
    (bildeId, miljokontrollId, observasjonId, payload) =>
      dispatch(
        putMiljokontrollObservasjonBilde(
          bildeId,
          miljokontrollId,
          observasjonId,
          payload,
        ),
      ),
    [dispatch],
  );
  const getMiljogebyrerHistorikkAction = useCallback(
    (id) => dispatch(getMiljogebyrerHistorikk(id)),
    [dispatch],
  );

  return (
    <BilderAndObservasjonsbilder
      {...rest}
      miljogebyrId={miljogebyrId}
      miljogebyr={miljogebyr}
      miljogebyrBilder={miljogebyrBilder}
      miljokontrollerThumbnailBilder={miljokontrollerThumbnailBilder}
      miljokontrollerLightboxBilder={miljokontrollerLightboxBilder}
      getMiljogebyr={getMiljogebyrAction}
      getMiljogebyrBilder={getMiljogebyrBilderAction}
      putMiljogebyrerBilder={putMiljogebyrerBilderAction}
      deleteMiljogebyrerBilder={deleteMiljogebyrerBilderAction}
      deleteMiljokontrollObservasjonBilde={
        deleteMiljokontrollObservasjonBildeAction
      }
      getMiljokontrollBilder={getMiljokontrollBilderAction}
      putMiljokontrollObservasjonBilde={putMiljokontrollObservasjonBildeAction}
      getMiljogebyrerHistorikk={getMiljogebyrerHistorikkAction}
    />
  );
}
